import React, { createContext, useContext, useState, useEffect } from 'react';

const FarmSelectionContext = createContext();

export const useFarmSelection = () => useContext(FarmSelectionContext);

export const FarmSelectionProvider = ({ children }) => {
  const [currentFarm, setCurrentFarmState] = useState(null);
  const [farmsList, setFarmsListState] = useState([]);

  // On mount, initialize currentFarm and farmsList from localStorage if available
  useEffect(() => {
    const storedFarm = localStorage.getItem('currentFarm');
    if (storedFarm) {
      try {
        setCurrentFarmState(JSON.parse(storedFarm));
      } catch (e) {
        // ignore parse error
      }
    }

    const storedFarmsList = localStorage.getItem('farmsList');
    if (storedFarmsList) {
      try {
        setFarmsListState(JSON.parse(storedFarmsList));
      } catch (e) {
        // ignore parse error
      }
    }
  }, []);

  // When currentFarm changes, update localStorage
  useEffect(() => {
    if (currentFarm) {
      localStorage.setItem('currentFarm', JSON.stringify(currentFarm));
    } else {
      localStorage.removeItem('currentFarm');
    }
  }, [currentFarm]);

  // When farmsList changes, update localStorage
  useEffect(() => {
    if (farmsList && farmsList.length > 0) {
      localStorage.setItem('farmsList', JSON.stringify(farmsList));
    } else {
      localStorage.removeItem('farmsList');
    }
  }, [farmsList]);

  // Custom setter to keep localStorage in sync
  const setCurrentFarm = (farm) => {
    setCurrentFarmState(farm);
    // localStorage is updated by the effect above
  };

  // Custom setter for farmsList to keep localStorage in sync
  const setFarmsList = (farms) => {
    setFarmsListState(farms);
    // localStorage is updated by the effect above
  };

  return (
    <FarmSelectionContext.Provider value={{ currentFarm, setCurrentFarm, farmsList, setFarmsList }}>
      {children}
    </FarmSelectionContext.Provider>
  );
}; 